export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    return
  }

  if (!import.meta.env.PROD) {
    navigator.serviceWorker.getRegistrations()
      .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
      .catch((error: unknown) => {
        console.warn('SGS Fee Portal development service worker cleanup failed.', error)
      })
    return
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error: unknown) => {
      console.warn('SGS Fee Portal service worker registration failed.', error)
    })
  })
}
